export const baseSkeletonClasses =
    "bg-gradient-to-r from-base-300 via-base-200 to-base-300 bg-[length:400%_100%] animate-[pulse_1.5s_ease-in-out_infinite_alternate]";

export const SkeletonTitle = ({ width = "w-48", height = "h-6", className = "" }) => (
    <div className={`${baseSkeletonClasses} rounded ${width} ${height} ${className}`}></div>
);

export const SkeletonLine = ({ width = "w-full", height = "h-4", className = "" }) => (
    <div className={`${baseSkeletonClasses} rounded ${width} ${height} ${className}`}></div>
);

export const SkeletonButton = ({ width = "w-32", height = "h-10", className = "" }) => (
    <div className={`${baseSkeletonClasses} rounded ${width} ${height} ${className}`}></div>
);

export const SkeletonToggle = ({ className = "" }) => (
    <div className={`${baseSkeletonClasses} rounded-full h-6 w-12 ${className}`}></div>
);

export const SkeletonImage = ({ width = "w-20", height = "h-20", className = "" }) => (
    <div className={`${baseSkeletonClasses} rounded-lg ${width} ${height} ${className}`}></div>
);

export const SkeletonCard = ({ children, className = "" }) => (
    <div className={`bg-base-100 rounded-xl p-6 ${className}`}>{children}</div>
);

export const SkeletonContainer = ({ children, className = "" }) => (
    <div className={`space-y-2 ${className}`}>{children}</div>
);
